import { PROFILE_CARD_QUERY_CUSTOM_KEY, createCustomMetric } from '@confluence/browser-metrics';
export const PROFILE_CARD_QUERY_METRIC = createCustomMetric({
	key: PROFILE_CARD_QUERY_CUSTOM_KEY,
});
